import catalog from "./permissions.generated.json"

// Werte aus permissions.generated.json (Kopie von 1001-01-backend/docs/migration/permissions.json).
// JSON-Importe sind in TS nur `string[]`, deshalb stehen die Unions hier als Literale; ability.test.ts prüft die Übereinstimmung mit dem JSON.
export const ACTIONS = [
    "manage",
    "create",
    "read",
    "update",
    "delete",
    "upload",
    "download",
    "readRestricted",
    "updateRestricted",
    "readOU",
    "updateOU",
    "managePermissions",
    "generateQrCode",
    "scopeSelf",
    "scopeCostCenter",
    "scopeAll",
    "checkInOut",
    "manualCheckInOut",
    "execute",
    "administer",
    "optimizeRoute",
    "readColor",
    "exportAll",
    "access",
] as const

export const SUBJECTS = [
    "all",
    "settings",
    "permission",
    "user",
    "role",
    "history",
    "apiKey",
    "dashboard",
    "employee",
    "accounting",
    "payment",
    "object",
    "customer",
    "costCenter",
    "task",
    "absence",
    "session",
    "orderRequest",
    "help",
    "report",
    "file",
    "customerPortal",
] as const

export type Action = (typeof ACTIONS)[number]
export type Subject = (typeof SUBJECTS)[number]

export type TPermission = {
    action: Action
    subject: Subject
    /** Recht gilt nur für die Ressource mit dieser `_id` (CASL-Bedingung). */
    subjectId?: string
}

// Schlüssel = Namen des früheren Rollen-Enums, Wert = rbac-Rolle. Behoben: `anfragen_create` war früher gleich `rbac_orderRequest_read`.
const LEGACY_ROLES = {
    anfragen_read: "rbac_orderRequest_read",
    anfragen_create: "rbac_orderRequest_create",
} as const

export type TPermissionKey = keyof typeof LEGACY_ROLES

const RBAC = catalog.rbac as Record<string, TPermission>

/** rbac-Rolle (z. B. "rbac_orderRequest_read") -> {action, subject} laut Katalog. */
export const permissionForRbacRole = (role: string): TPermission | undefined => {
    const permission = RBAC[role]
    return permission ? { action: permission.action, subject: permission.subject } : undefined
}

/** `P.anfragen_read` = `{ action: "read", subject: "orderRequest" }`, `P.anfragen_create` = `{ action: "create", subject: "orderRequest" }`. */
export const P = Object.fromEntries(Object.entries(LEGACY_ROLES).map(([key, role]) => [key, permissionForRbacRole(role)])) as Record<
    TPermissionKey,
    TPermission
>
